// url details of qa
export let apiURL =
{

   // "URL": "http://localhost:3000/api/v1"
   //new link
   "URL": "https://ney2u24bjh.execute-api.us-east-1.amazonaws.com/prod/api/v1"
};

export let webURL =
{
   // "URL": "http://localhost:4200/"
   "URL": "https://lsm-prod.d3c1prqo5wb2hu.amplifyapp.com"
};

export let secretKey = "SecretSuperCs";

